import React, { useState } from "react";
import { Button, Dialog } from "@mui/material";
import { DialogContent, Stack, TextField, Typography } from "@mui/material";
import LedgersRepository from "../../Repository/LedgersRepository";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { Toast } from "../components/Toast";
import { BtnCancel } from "../styles";
import { entryRemove, entryAdded } from "./detailSlice";
import { sendEmailNotification } from "../bills/httpCalls";

function AddEntry({ open, onClose }) {
  const dispatch = useDispatch();
  const { type, selected } = useSelector((state) => state.ledger);
  const { detail } = useSelector((state) => state.ledgerDetail);
  console.log("detail:", detail);
  let balance = detail.length > 0 ? detail[0]?.balance : 0;
  const [state, setState] = useState({
    detail: "",
    totalAmount: 0,
    depositedAmount: 0,
  });

  const handleSubmit = async () => {
    try {
      let updateType =
        type == "purchase" ? "updatePurchaseLedger" : "updateSaleLedger";

      if (!selected._id) {
        Toast("info", "Kindly Select a ledger");
        return;
      }
      let remaining =
        parseInt(state.totalAmount || 0) - parseInt(state.depositedAmount || 0);
        console.log('state', state.totalAmount)
        console.log('deposit', state.depositedAmount)
      onClose();
      let entry = {
        srNum: uuidv4(),
        date: +new Date(),
        detail: state.detail,
        totalAmount: state.totalAmount,
        depositedAmount: state.depositedAmount ?  state.depositedAmount : 0,
        remainingAmount: remaining ? remaining : "0",
      };
      balance += remaining;

      dispatch(entryAdded({ entry, balance }));
      const startTime = performance.now();
      let { data } = await LedgersRepository.ledgerModel({
        request: {
          method: updateType,
          data: {
            _id: selected._id,
            [type]: entry,
          },
        },
      });
      if (data.response.data.ledger) {

        const endTime = performance.now(); // Record the end time
        const responseTime = endTime - startTime; // Calculate response time
        console.log("Response Time:", responseTime);
    
        // Check if response time exceeds 20 seconds
        if (responseTime > 20000) { // 20000 milliseconds = 20 seconds
          await sendEmailNotification(updateType); // Trigger email notification
          // toast.success("Email notification sent successfully!");
        }
        Toast("success", "Ledger Entry created");
      } else {
        dispatch(entryRemove({ entry }));
        Toast("error", "Ledger Entry Not created");
      }
    } catch (error) {
      console.log("error:", error);
      Toast("error", "Error");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Dialog
      title="Add Entry"
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
    >
      <DialogContent>
        <Stack direction="column" spacing={2}>
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            Add New Entry
          </Typography>
          <TextField
            autoFocus
            size="small"
            label="Details"
            fullWidth
            name="detail"
            value={state.detail}
            onChange={handleChange}
          />
          <TextField
            size="small"
            type="number"
            label="Total Amount"
            fullWidth
            name="totalAmount"
            value={state.totalAmount}
            onChange={handleChange}
          />
          <TextField
            size="small"
            label="Deposited Amount"
            type="number"
            name="depositedAmount"
            fullWidth
            value={state.depositedAmount}
            onChange={handleChange}
          />

          <Stack direction="row" justifyContent="center" spacing={3}>
            <Button variant="contained" onClick={handleSubmit}>
              Add Ledger Entry
            </Button>
            <BtnCancel onClick={onClose}>Cancel</BtnCancel>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default AddEntry;
